/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Trust_One_TimeInputs */

const en_pricing_trust_one_time = /** @type {(inputs: Pricing_Trust_One_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time payment, no subscription`)
};

const es_pricing_trust_one_time = /** @type {(inputs: Pricing_Trust_One_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago único, sin suscripción`)
};

/**
* | output |
* | --- |
* | "One-time payment, no subscription" |
*
* @param {Pricing_Trust_One_TimeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_trust_one_time = /** @type {((inputs?: Pricing_Trust_One_TimeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Trust_One_TimeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_trust_one_time(inputs)
	return es_pricing_trust_one_time(inputs)
});